var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 180 180",
    style: {
      enableBackground: "new 0 0 180 180"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#1A1A1A;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M90,35.2c-28.1,0-51,22.9-51,51c0,10.2,3,20,8.6,28.4l0.6,0.9l83.8-0.4l0.6-0.9c5.5-8.3,8.3-18,8.3-27.9 C141,58.1,118.1,35.2,90,35.2z M129.9,111l-79.5,0.4c-4.8-7.5-7.4-16.3-7.4-25.3c0-25.9,21.1-47,47-47c25.9,0,47,21.1,47,47 C137,95,134.5,103.6,129.9,111z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M124.9,77.6L96.6,93.4c-1.6-1.6-3.8-2.7-6.2-2.7c-4.7,0-8.6,3.8-8.6,8.6s3.8,8.6,8.6,8.6S99,104,99,99.3 c0-0.9-0.1-1.7-0.4-2.5l28.3-15.7c1-0.5,1.3-1.8,0.8-2.7C127.1,77.4,125.9,77.1,124.9,77.6z M90.4,103.9c-2.5,0-4.6-2.1-4.6-4.6 s2.1-4.6,4.6-4.6c2.5,0,4.6,2.1,4.6,4.6S92.9,103.9,90.4,103.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59.3,95.1C59.3,95.1,59.3,95.1,59.3,95.1L55,95.2c-1.1,0-2,0.9-2,2c0,1.1,0.9,2,2,2c0,0,0,0,0,0l4.3-0.1 c1.1,0,2-0.9,2-2C61.3,96,60.4,95.1,59.3,95.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M124.5,95.3h-3.7c-1.1,0-2,0.9-2,2s0.9,2,2,2h3.7c1.1,0,2-0.9,2-2S125.6,95.3,124.5,95.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M89.1,52.7c1.1,0,2-0.9,2-2v-6.5c0-1.1-0.9-2-2-2s-2,0.9-2,2v6.5C87.1,51.8,88,52.7,89.1,52.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M61.6,63.4l-4.2-2.3c-1-0.5-2.2-0.2-2.7,0.8c-0.5,1-0.2,2.2,0.8,2.7l4.2,2.3c0.3,0.2,0.6,0.3,1,0.3 c0.7,0,1.4-0.4,1.8-1C62.9,65.2,62.5,64,61.6,63.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M120.8,67.7c0.5,0,0.9-0.2,1.3-0.5l3.7-3.3c0.8-0.7,0.9-2,0.2-2.8s-2-0.9-2.8-0.2l-3.7,3.3 c-0.8,0.7-0.9,2-0.2,2.8C119.7,67.4,120.2,67.7,120.8,67.7z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M49.5,140.1v1.7h-3.3V160h-2.1v-18.2h-10v-1.7H49.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3,145.7c0-1.2-0.4-2.2-1.1-2.9c-0.7-0.7-1.7-1.1-2.8-1.1h-7.1v-1.7h7c1.3,0,2.3,0.2,3.2,0.7c0.9,0.5,1.6,1.1,2.1,2 c0.5,0.9,0.7,1.9,0.7,3.2V160h-2.1V145.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3,141.8h-2.6v-1.7h4.7V160h-2.1V141.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.4,158.4v1.6h-16v-1.7h11.5v-10.6c0-1.4-0.2-2.5-0.6-3.4c-0.4-0.9-1-1.5-1.9-1.9c-0.9-0.4-2-0.6-3.4-0.6h-4.5v-1.7h4.6 c2.6,0,4.6,0.6,5.9,1.9c1.3,1.3,1.9,3.2,1.9,5.7v10.5L99.4,158.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.2,157.1c1.2,0.5,2.3,0.9,3.6,1.2c1.2,0.3,2.5,0.4,3.6,0.4c1.7,0,3.1-0.2,4.5-0.7c1.3-0.5,2.4-1.2,3.1-2.2 c0.8-1,1.2-2.2,1.2-3.6v-12.1h2v12.3c0,1.8-0.5,3.2-1.4,4.5c-1,1.2-2.2,2.1-3.9,2.7c-1.6,0.6-3.4,0.9-5.4,0.9 c-1.5,0-3.1-0.2-4.7-0.5c-1.6-0.4-3.2-0.9-4.6-1.6v-18.2h2V157.1z M114.1,150.4v-10.4h2.1v10.1c0,1.2-0.1,2.1-0.4,2.9 s-0.8,1.5-1.4,2.1l-1.8-0.2C113.6,154.1,114.1,152.6,114.1,150.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.5,140.1v1.7h-3.3V160h-2.1v-18.2h-10v-1.7H146.5z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.dc47b0ea2dbcec1cb41ecb9611a558e5.svg";
export { ForwardRef as ReactComponent };